module.exports = __webpack_public_path__ + "media/images/emblems/Confignon-coat_of_arms-966723434fdde4f81e97427e7d9371f9.svg";